import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Person } from 'src/app/assabil-kernel/models/entities/master-data/person-entity';

@Injectable({
  providedIn: 'root',
})
export class LeanUtilsService {

  
  showStockInPurchasePacks  : boolean = true;
  serialNumberlength        : number = 0;
  barCodelength             : number = 0;

  printPdf(pdf : string) {
    const pdfBlob = this.dataURItoBlob(pdf);
    const fileURL = URL.createObjectURL(pdfBlob);
    window.open(fileURL, '_blank');
  }


  moduleMenu = "Nothing"
  sideBarMenu = [];
  contexts = new Map();

  constructor(public toastr: ToastrService) { }

  public put(key: string, data: any): Promise<boolean> {
    this.contexts.set(key, data);
    return Promise.resolve(this.contexts.get(key));
  }
  public get(key: string): Promise<any> {
    const data = this.contexts.get(key);
    if (data !== null && data !== undefined) {
      return Promise.resolve(data);
    } else {
      return Promise.resolve(null);
    }
  }
  public clearAll() {
    this.contexts.clear();
  }

  public timePipe(value: any, ...args: any[]) {
    const datePipe = new DatePipe('en-US');
    value = datePipe.transform(value, 'HH:mm');
    return value;
  }

  public dateTimePipe(value: any, ...args: any[]) {
    const datePipe = new DatePipe('en-US');
    value = datePipe.transform(value, 'dd-MM-yyyy HH:mm');
    return value;
  }
    

  longToDatePipe(value: any, ...args: any[]) {
    let result = "---";
    try {
      const datePipe = new DatePipe('en-US');
      result = datePipe.transform(new Date(value), 'dd-MM-yyyy');
    } catch(error){

    }
    return result;
  }

  datePipe(value: any, ...args: any[]) {
    let result = "---";
    try {
      const datePipe = new DatePipe('en-US');
      result = datePipe.transform(value, 'dd-MM-yyyy');
    } catch(error){

    }
    return result;
  }

  datePipeddMM(value: any, ...args: any[]) {
    let result = "---";
    try {
      const datePipe = new DatePipe('en-US');
      result = datePipe.transform(value, 'dd-MM');
    } catch(error){

    }
    return result;
  }
  datePipeDD(value: any, ...args: any[]) {
    let result = "---";
    try {
      const datePipe = new DatePipe('en-US');
      result = datePipe.transform(value, 'dd');
    } catch(error){

    }
    return result;
  }
  public booleanPipe(value: any, ...args: any[]) {
    if (!value) {
      return '-';
    } else {
      return value;
    }
  }

  success() {
    this.toastr.success("Opération effectuée avec succès");
  }

  info(msg : string) {
    this.toastr.info(msg);
  }
  error(msg : string) {
    this.toastr.error(msg);
  }

  getPersonName(person : Person) : string{
    if (! person) return "";
    let name : string = "";
    if ( (person.firstName) && (person.firstName.trim() != '.')) name = person.firstName + " ";
    if ( (person.name) && (person.name.trim() != '.')) name += person.name;
    return name;
  }
  
  dataURItoBlob(dataURI) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: 'application/pdf' });    
    return blob;
 }

  getField(fieldName  : string, columns : any[]) : any{
    if ((columns == undefined) || (columns.length == 0)){
      return  { prop: fieldName, name: fieldName, readOnly: false };
    } else {
    return  columns.find(x => x.prop == fieldName);
    }
  }

  isBlank(v : string) : boolean{
    if (v == null)      return true;
    if (v == undefined) return true;
    if (v.trim() == "")        return true;
    return false;
  }

  round(p : number, decimals : number){
    if (p == 0) return undefined;
    if (! decimals) decimals = 0;
    let pw = Math.pow(10, decimals);
    p = p * pw;
    p = Math.round(p);
    p = p / pw;
    return p;
  }

  zeroToNull(p : number){
    if (p == 0) return undefined;
    return p;
  }

  nullToZero(p : number){
    if (! p) return 0;
    return p;
  }

  checkPhoneNumberFormat(phone : string) : boolean {
    if (!phone) return false;
    if (phone.trim()=="") return false;
    let c = phone.substring(0,1);
    if ((c != '+') && (c!='0')) return false;
    if (c == '+') phone = phone.substring(1);
    if (! Number(phone)) return false;
    if (phone.length < 9) return false;
  return true;
}
}
